import React from 'react';

import Page from 'components/page/Page';
import RequestPasswordResetForm from '../../components/request-password-reset-form/RequestPasswordResetForm';
import AccessContainerHeader from '../../components/access-container/access-container-header/AccessContainerHeader';
import AccessContainer from '../../components/access-container/AccessContainer';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./request-password-reset-page.i18n.json'));

const RequestPasswordResetPage = () => (
  <Page
    documentTitle={__t('request_password_reset_page.title')}
  >
    <AccessContainer type="request-password">
      <AccessContainerHeader title={__t('request_password_reset_page.title')} />
      <RequestPasswordResetForm />
    </AccessContainer>
  </Page>
);

export default RequestPasswordResetPage;
